import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { ToastModule } from 'primeng/toast';
import { ButtonModule} from 'primeng/button';
import { TabViewModule} from 'primeng/tabview';
// import { CodeHighlighterModule } from 'primeng/codehighlighter';
import { TableModule } from 'primeng/table';
import { DialogModule } from 'primeng/dialog';
import { DropdownModule } from 'primeng/dropdown';
import { InputTextModule } from 'primeng/inputtext';
import { SliderModule } from 'primeng/slider';
import { MultiSelectModule } from 'primeng/multiselect';
import { FormsModule,ReactiveFormsModule } from '@angular/forms';
import {CalendarModule} from 'primeng/calendar';
import {RadioButtonModule} from 'primeng/radiobutton';
import {InputSwitchModule} from 'primeng/inputswitch';
import {ConfirmDialogModule} from 'primeng/confirmdialog';
import {ConfirmationService} from 'primeng/api';
import {MessageService} from 'primeng/api';
import {CheckboxModule} from 'primeng/checkbox';
import {AccordionModule} from 'primeng/accordion';
import {ChipsModule} from 'primeng/chips';
import { AutoCompleteModule } from 'primeng/autocomplete';
import { SimpleTableModule } from 'src/app/components/table/simple-table/simple-table.modules';
import { PipeModule } from 'src/app/pipes/pipe.module';
import { GenericDesplegableModule } from '../../components/deplegable/generic-dropdown/generic-dropdown.module';

import { ArticulosProveedorListComponent } from './articulos-proveedor-list/articulos-proveedor-list.component';
import { ArticulosProveedorCreateComponent } from './articulos-proveedor-create/articulos-proveedor-create.component';
import { AppArticulosRoutingModule } from './app.articulos.routes';
import {PanelModule} from 'primeng/panel';
import { WebcamModule } from 'ngx-webcam';
import { CardModule } from 'primeng/card';
import { CameraModule } from 'src/app/components/camera/camera.modules';
import { UserLoginService } from '@/app/services/UserLogin/UserLoginService';


@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    ToastModule,
    ButtonModule,
    TabViewModule,
    // CodeHighlighterModule,
    TableModule,
    DialogModule,
    DropdownModule,
    InputTextModule,
    MultiSelectModule,
    SliderModule,
    CalendarModule,
    RadioButtonModule,
    InputSwitchModule,
    ConfirmDialogModule,
    CheckboxModule,
    AccordionModule,
    ChipsModule,
    AutoCompleteModule,
    SimpleTableModule,
    GenericDesplegableModule,
    PipeModule,
    PanelModule,
    WebcamModule,
    CardModule,
    CameraModule,
    AppArticulosRoutingModule,
  ],
  declarations: [
    ArticulosProveedorCreateComponent,
    ArticulosProveedorListComponent,
    ],
  exports: [ArticulosProveedorListComponent, ArticulosProveedorCreateComponent],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  providers:[
    MessageService,
    ConfirmationService,
    UserLoginService,    
  ]
})
export class AppArticulosModule { }
